import styled from '@emotion/styled';
import { Button, SpaceDivider, Text } from '@innovationdepartment/proxima-ui';
import ButtonGroup from 'ui/ButtonGroup';
import LoadingSpinner from 'ui/LoadingSpinner';

type DeleteTagConfirmationViewProps = {
  confirm: () => void;
  close: () => void;
  tagDisplayName: string;
  isLoading: boolean;
};

const TextWrapper = styled.div`
  & p {
    font-weight: 400;
  }
`;

const LoadingSpinnerWrapper = styled.div`
  display: block;
  width: 30vw;
  text-align: center;
`;

const DeleteTagConfirmationView = ({
  confirm,
  close,
  tagDisplayName,
  isLoading
}: DeleteTagConfirmationViewProps) => (
  <TextWrapper>
    {isLoading ? (
      <LoadingSpinnerWrapper>
        <LoadingSpinner size={100} />
      </LoadingSpinnerWrapper>
    ) : (
      <>
        <SpaceDivider y={2} />
        <Text variant="body1">
          Are you sure you want to delete <strong>{tagDisplayName}</strong>?
        </Text>
        <SpaceDivider y={6} />
        <ButtonGroup>
          <Button size="small" variant="outlined" label="Cancel" onClick={close} />
          <Button size="small" color="error" label="Confirm" onClick={confirm} />
        </ButtonGroup>
      </>
    )}
  </TextWrapper>
);

export default DeleteTagConfirmationView;
